var _rect, _rect2, _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 920,
    viewBox: "0 0 680 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 920,
    rx: 30,
    fill: "#F3F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 561,
    width: 349,
    height: 359,
    fill: "url(#paint0_linear_680_30160)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.835 503.305C333.708 501.802 338.915 501.764 343.809 503.198L507.539 551.159C517.745 554.149 517.812 568.584 507.634 571.668L344.046 621.24C339.005 622.768 333.619 622.728 328.601 621.127L173.482 571.62C163.502 568.435 163.571 554.291 173.581 551.202L328.835 503.305Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_680_30160)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.878,
    cy: 556.103,
    rx: 55.9831,
    ry: 5.885,
    transform: "rotate(-14 352.878 556.103)",
    fill: "#7294FF",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_30160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.632 378.85L357.881 363.677C347.797 360.474 335.207 364.384 325.123 373.848L277.372 418.675C267.782 427.678 261.917 440.349 261.917 452.058V522.058C261.917 535.866 278 545 278 545L397.211 505.048C410.399 500.953 421.087 486.442 421.087 472.634L425 393C425 393 415.222 381.897 405.632 378.85Z",
    fill: "url(#paint1_linear_680_30160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.632 387.85L368.881 372.677C358.797 369.474 346.207 373.384 336.123 382.848L288.372 427.675C278.782 436.678 272.917 449.349 272.917 461.058V531.058C272.917 544.866 283.605 552.739 296.792 548.644L408.211 514.048C421.399 509.953 432.087 495.442 432.087 481.634V411.634C432.087 399.926 426.222 390.897 416.632 387.85Z",
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.294 393.99L312.709 418.702C303.915 421.432 296.792 431.102 296.792 440.311V473.644L352.502 481.346L408.211 439.048V405.714C408.211 396.506 401.089 391.259 392.294 393.99Z",
    fill: "#BDCEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_680_30160",
    x: 284.539,
    y: 527.401,
    width: 136.678,
    height: 57.4038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_680_30160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_680_30160",
    x1: 515,
    y1: 740.5,
    x2: 166,
    y2: 740.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_680_30160",
    x1: 415.5,
    y1: 379,
    x2: 320.244,
    y2: 566.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6188FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6188FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#97B2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5BDFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_30160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "matrix(0.95502 -0.296542 0 1 257 386)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.699968133dba5ee285d51acc9d15897a.svg";
export { ForwardRef as ReactComponent };